import { AnyAction, combineReducers, Reducer } from "redux";
import { Auth, LoginHistoryReducer, ChangePasswordReducer, ResetPasswordReducer, GenerateOtpReducer, ValidateOtpReducer } from "./auth/reducers";
import { FieldConfigListReducer } from "./fieldsConfig/reducer";
import WorkspaceTabs from "./workspaceTabs/reducer";
import { APP_CLEAR_STORE } from "./appConstants";
import {
  FinancierUserListUiReducer,
  FinancierUserListReducer,
  CreateFinancierUserReducer,
  FinancierUserReducer,
  UpdateFinancierUserReducer,
  FetchFinancierUserVesrions,
  ApproveFinancierUserReducer,
  RejectFinancierUserReducer,
  BlockFinancierUserReducer,
  FreezeFinancierUserReducer,
  UnFreezeFinancierUserReducer,
  FetchFinancierUserVesrionDetails,
  DeleteFinancierUserReducer,
  FetchFinancierUserLatestVesrionReducer
} from "./financierUser/reducers";

import {
  UserRoleListUiReducer,
  UserRoleListReducer,
  CreateUserRoleReducer,
  UserRoleReducer,
  UpdateUserRoleReducer,
  FetchUserRoleVesrions,
  ApproveUserRoleReducer,
  RejectUserRoleReducer,
  ModulePermissionListReducer,
  FetchUserRoleVesrionsDetails,
  FetchUserRoleLatestVesrionsReducer,
  DeleteUserRoleReducer
} from "./userRoles/reducers";
import {
  CurrencyListUiReducer,
  CurrencyVersionListReducer,
  aproveCurrencyReducer,
  rejectCurrencyReducer,
  blockCurrencyReducer,
  CurrencyListReducer,
  CreateCurrencyReducer,
  CurrencyReducer,
  UpdateCurrencyReducer,
  DeleteCurrencyReducer,
  FreezeCurrencyReducer,
  UnFreezeCurrencyReducer,
  CurrencyVersionDetailsReducer,
  FetchCurrencyLatestVerionReducer
} from "./currency/reducer";
import {
  BaseRateListUiReducer,
  BaseRateListReducer,
  CreateBaseRateReducer,
  BaseRateReducer,
  NormalBaseRateReducer,
  AdhocBaseRateReducer,
  UpdateBaseRateReducer,
  FetchBaseRateVesrions,
  ApproveBaseRateReducer,
  RejectBaseRateReducer,
  BlockBaseRateReducer,
  FreezeBaseRateReducer,
  UnFreezeBaseRateReducer,
  FetchBaseRateVesrionsDetailsReducer,
  BaseRateReducerLatestVersionReducer,
  DeleteBaseRateReducer
} from "./baseRate/reducer";
import {
  HolidayListUiReducer,
  HolidayListReducer,
  HolidayLatestVersionReducer,
  DeleteHolidayReducer,
  CreateHolidayReducer,
  HolidayReducer,
  UpdateHolidayReducer,
  FetchHolidayVesrions,
  ApproveHolidayReducer,
  RejectHolidayReducer,
  BlockHolidayReducer,
  FreezeHolidayReducer,
  UnFreezeHolidayReducer,
  HolidayVersionDetailsReducer
} from "./holiday/reducer";

import {
  HolidayBatchListUiReducer,
  HolidayBatchListReducer,
  CreateHolidayBatchReducer,
  HolidayBatchReducer,
  UpdateHolidayBatchReducer,
  FetchHolidayBatchVesrions,
  ApproveHolidayBatchReducer,
  RejectHolidayBatchReducer,
  PublishHolidayBatchReducer,
  HolidayBatchFilterReducer,
  HolidayBatchVersionDetailsReducer,
  DownloadHolidayBatchReducer
} from "./holidayBatch/reducer";
import {
  BranchListUiReducer,
  BranchListReducer,
  CreateBranchReducer,
  BranchReducer,
  FetchBranchVesrions,
  ApproveBranchReducer,
  RejectBranchReducer,
  UpdateBranchReducer,
  BlockBranchReducer,
  FreezeBranchReducer,
  UnFreezeBranchReducer,
  BranchVersionDetailsReducer,
  BranchReducerLatestVerionReducer,
  DeleteBranchReducer
} from "./branch/reducer";
import Layout from "./layout/reducers";

import {
  CountryListUiReducer,
  CountryListReducer,
  CountryReducer,
  CreateCountryReducer,
  UpdateCountryReducer,
  CountryVersionListReducer,
  approveCountryReducer,
  rejectCountryReducer,
  blockCountryReducer,
  FreezeCountryReducer,
  UnFreezeCountryReducer,
  CountryVersionDetailsReducer,
  CountryReducerLatestVersionReducer,
  DeleteCountryReducer
} from "./country/reducers";
import {
  StateListUiReducer,
  StateListReducer,
  CreateStateReducer,
  StateReducer,
  UpdateStateReducer,
  StateListVersionReducer,
  ApproveStateReducer,
  RejectStateReducer,
  BlockStateReducer,
  FreezeStateReducer,
  UnFreezeStateReducer,
  StateVersionDetailsReducer,
  StateLatestVersionReducer,
  DeleteStateReducer
} from "./state/reducers";
import {
  SystemParameterListUiReducer,
  SystemParameterListReducer,
  SystemParameterReducer,
  UpdateSystemParameterReducer,
  SystemParameterListVersionReducer,
  SystemParameterVersionDetailsReducer,
  SystemParameterLatestVersionReducer,
  ApproveSystemParameterReducer,
  RejectSystemParameterReducer
} from "./systemParameters/reducers";
import {
  AgeingBucketsReducer,
  DashboardOperationsSummaryReducer,
  DashboardPortfolioAnalyticsSummaryReducer,
  DisbursementByFYGraphReducer,
  ProductMixReducer,
  ProgramPerformanceReducer,
  RenewalAndExpiryReducer,
  TxnsByUserReducer
} from "./dashboard/reducer";
import {
  CityListUiReducer,
  CityListReducer,
  CreateCityReducer,
  CityReducer,
  UpdateCityReducer,
  CityListVersionReducer,
  ApproveCityReducer,
  RejectCityReducer,
  BlockCityReducer,
  FreezeCityReducer,
  UnFreezeCityReducer,
  CityVersionDetailsReducer,
  CityReducerLatestVersionReducer,
  DeleteCityReducer
} from "./city/reducers";
import { ZipLookupReducer } from "./pincode/reducer";
import {
  RelationshipManagerListUiReducer,
  RelationshipManagerListReducer,
  RelationshipMaanagerReducer,
  CreaterelationshipManagerReducer,
  UpdateRelationshipMaanagerReducer,
  RelationshipManagerListVersionReducer,
  AproveRelationshipManagerReducer,
  RejectRelationshipManagerReducer,
  BlockRelationshipManagerReducer,
  FreezeRelationshipManagerReducer,
  UnFreezeRelationshipManagerReducer,
  RelationshipMaanagerVersionDetailsReducer,
  RelationshipMaanagerLatestVersionReducer,
  DeleteRelationshipMaanagerReducer
} from "./relationshipManager/reducer";
import {
  LovListUiReducer,
  LovListReducer,
  CreateLovListReducer,
  LovByIdReducer,
  UpdateLovReducer,
  LovListTenorReducer,
  LovListVersionReducer,
  AproveLovReducer,
  RejectLovReducer,
  BlockLovReducer,
  FreezeLovReducer,
  UnFreezeLovReducer,
  LovListVersionDetailsReducer,
  LovLatestVersionReducer,
  deleteLOVReducer
} from "./lov/reducer";
import {
  TaskIdByPanNumberReducer,
  TaskStatusByTaskIdReducer,
  TaskResultByTaskIdReducer,
  CustomerIdsReducer,
  CustomerListReducer,
  CustomerListUiReducer,
  CustomerReducer,
  CustomerValidateReducer,
  ApproveCustomerReducer,
  RejectCustomerReducer,
  SentBackCustomerReducer,
  CustomerBlockReducer,
  GstDetailReducer,
  CustomerVersionsReducer,
  CreateCustomerReducer,
  UpdateCustomerReducer,
  DeDuplicateCustomerReducer,
  CustomerFreezeReducer,
  CustomerUnFreezeReducer,
  CustomerVersionsDetailsReducer,
  CustomerLatestVersionsReducer,
  DeleteCustomerReducer,
  FetchCustomerByProgrammeIdReducer
} from "./customer/reducer";

import {
  CustomerCICReportingIdsReducer,
  CustomerCICReportingListReducer,
  CustomerCICReportingReducer,
  CustomerCICReportingVersionReducer,
  CustomerCICReportingLatestVersionReducer,
  CustomerCICReportingVersionsDetailReducer,
  CreateCustomerCICReportingReducer,
  DeleteCustomerCICReportingReducer,
  ApproveCustomerCICReportingReducer,
  RejectCustomerCICReportingReducer,
  SentBackCustomerCICReportingReducer,
  UpdateCustomerCICReportingReducer,
  CustomerCICReportingListUiReducer
} from "./customerCICReporting/reducer";
import {
  CreateCustomerContactReducer,
  CustomerContactListReducer,
  CustomerContactBYIdReducer,
  UpdateCustomerContactReducer,
  CreatePartnerContactReducer,
  CreateKeyManagmentContactReducer,
  KeyManagementContactListReducer,
  KeyManagementContactReducer,
  UpdateKeyManagementContactReducer,
  FetchPatnerContactListReducer,
  FetchPartnerContactBYIdReducer,
  UpdatePartnerContactReducer,
  CustomerContactListVersionReducer,
  AproveCustomerContactReducer,
  RejectCustomerContactReducer,
  SentBackCustomerContactReducer,
  BlockCustomerContactReducer,
  KeyManagementListVersionReducer,
  AproveKeyManagementReducer,
  RejectKeyManagementReducer,
  SentBackKeyManagementReducer,
  BlockKeyManagementReducer,
  PartnerContactListVersionReducer,
  AprovePartnerContactReducer,
  RejectPartnerContactReducer,
  SentBackPartnerContactReducer,
  BlockPartnerContactReducer,
  FreezeCustomerContactReducer,
  FreezePartnerContactReducer,
  FreezeKeyManagementReducer,
  UnFreezePartnerContactReducer,
  UnFreezeKeyManagementReducer,
  UnFreezeCustomerContactReducer,
  CustomerContactVersionDetailsReducer,
  DeleteCustomerContactReducer
} from "./customerContact/reducer";
import {
  CustomerAddressListReducer,
  CreateAddressReducer,
  CustomerAddressReducer,
  UpdateCustomerAddressReducer,
  AddressListVersionReducer,
  AproveCustomerAddressReducer,
  RejectCustomerAddressReducer,
  SentBackCustomerAddressReducer,
  BlockCustomerAddressReducer,
  FreezeCustomerAddressReducer,
  UnFreezeCustomerAddressReducer,
  FetchAddressVersionDetailsReducer,
  FetchAddressLatestVersionReducer,
  DeleteAddressReducer
} from "./customerAddress/reducer";
import {
  CustomerCummunicationsListReducer,
  CustomerCummunicationsCreatereducer,
  CustomerCummunicationsBYIdReducer,
  UpdateCustomerCummunicationsReducer,
  CustomerCummunicationsListVersionReducer,
  AproveCummunicationsReducer,
  RejectCummunicationsReducer,
  SentBackCummunicationsReducer,
  BlockCummunicationsReducer,
  FreezeCummunicationsReducer,
  UnFreezeCummunicationsReducer,
  CustomerCummunicationsVersionDetailsReducer,
  CustomerCummunicationsLatestVersionReducer,
  DeleteCustomerCummunicationsReducer
} from "./customerCummications/reducers";
import {
  LimitConfigListReducer,
  CreateLimitConfigReducer,
  deleteLimitConfigReducer,
  FetchLimitConfigReducer,
  UpdateLimitConfigReducer,
  FetchLimitConfigVesrions,
  ApproveLimitConfigReducer,
  RejectLimitConfigReducer,
  SentBackLimitConfigReducer,
  BlockLimitConfigReducer,
  FreezeLimitConfigReducer,
  UnFreezeLimitConfigReducer,
  FetchLimitConfigHistroyReducer,
  FetchLimitConfigVersionDetailsReducer,
  FetchLimitConfigLatestVersionReducer,
  FetchAggregateLimitConfigHistroyReducer,
  LimitConfigIdsReducer,
  FetchLimitConfigByCustomerReducer
} from "./limitConfig/reducer";
import { ProductLimitConfigListReducer, CreateProductLimitConfigReducer, UpdateProductLimitConfigReducer, FetchProductLimitConfigReducer } from "./productLimitConfig/reducer";
import { ListApprovedLimitsV2Reducer, LatestVersionLimitsV2Reducer, CreateDraftLimitV2Reducer, PublishLimitV2Reducer, UpdateDraftLimitV2Reducer, ApproveLimitV2Reducer, RejectLimitV2Reducer, SentBackLimitV2Reducer, DeleteLimitV2Reducer, DeleteLimitV2ByExternalIdReducer, FreezeLimitV2Reducer, UnfreezeLimitV2Reducer,
  LimitConfigListUiReducer
 } from "./limitConfigV2/reducer";
import {
  ProductTypeListUiReducer,
  ProdcutTypeListReducer,
  ProdcutTypeReducer,
  UpdateProductTypeReducer,
  CreateProdcutTypeReducer,
  ProdcutTypeListVersionReducer,
  RejectProductTypeReducer,
  AproveProductTypeReducer,
  BlockProductTypeReducer,
  FreezeProductTypeReducer,
  UnFreezeProductTypeReducer,
  ProdcutTypeDetailsReducer,
  ProdcutTypeLatestVersionReducer,
  DeleteProductTypeReducer
} from "./productType/reducer";
import {
  CreateCustomerBeneficiaryReducer,
  CustomerBeneficiaryListReducer,
  CustomerBeneficiaryReducer,
  UpdateBeneficiaryReducer,
  CustomerBeneficiaryVersionListReducer,
  AproveBeneficiaryReducer,
  RejectBeneficiaryReducer,
  SentBackBeneficiaryReducer,
  BlockBeneficiaryReducer,
  FreezeBeneficiaryReducer,
  UnFreezeBeneficiaryReducer,
  CustomerBeneficiaryVersionDetailsReducer,
  CustomerBeneficiaryLatestVersionReducer,
  DeleteCustomerBeneficiaryReducer
} from "./customerBeneficary/reducer";
import {
  ApproveFinancinProgramReducer,
  CreateFinancinProgramReducer,
  FinancingProgramListReducer,
  FinancingProgramListUiReducer,
  FinancingProgramValidateReducer,
  FinancingProgramVersionsReducer,
  FinancinProgramReducer,
  RejectFinancinProgramReducer,
  SentBackFinancinProgramReducer,
  UpdateFinancinProgramReducer,
  FinancinProgramVersionDetailsReducer,
  FinancingProgramLatestVersionsReducer,
  DeleteFinancinProgramReducer,
  GenerateLoanAccountNumberFinancinProgramReducer,
  BlockFinancingProgramReducer,
  FreezeFinancingProgramReducer,
  UnFreezeFinancingProgramReducer,
  FinancingProgramIdsReducer,
  FinancingProgramConfigListReducer,
  FinancingProgramForRepaymentsReducer
} from "./financingPrograms/reducer";
import {
  BuyerSellerIdsReducer,
  BuyerSellersListReducer,
  BuyerSellerListUiReducer,
  BuyerSellerCreateRelationAccountNumberReducer,
  BuyerSellerVersionDetailsReducer,
  BuyerSellerLatestVersionReducer,
  DeleteBuyerSellerReducer,
  BuyerSellerReducer,
  BuyerSellerVersionsReducer,
  ApproveBuyerSellerReducer,
  RejectBuyerSellerReducer,
  SentBackBuyerSellerReducer,
  BuyerSellerBlockReducer,
  UpdateBuyerSellerReducer,
  BuyerSellerValidateReducer,
  CreateBuyerSellerReducer,
  FreezeBuyerSellerReducer,
  UnFreezeBuyerSellerReducer,
  BuyerSellerPartialDisbursementAllowedReducer,
  BuyerSellerConfigValues,
  ProgrammeAndCounterparyBasedBuyerSellerReducer
} from "./buyerSeller/reducer";

import {
  CustomerBeneficiaryProgrammeListReducer,
  CreateCustomerBeneficiaryProgrammeReducer,
  CustomerBeneficiaryProgrammeReducer,
  UpdateBeneficiaryProgrammeReducer,
  CustomerBeneficiaryProgrammeVersionListReducer,
  AproveBeneficiaryProgrammeReducer,
  RejectBeneficiaryProgrammeReducer,
  BlockBeneficiaryProgrammeReducer,
  FreezeBeneficiaryProgrammeReducer,
  UnFreezeBeneficiaryProgrammeReducer
} from "./customerBeneficaryProgrammme/reducer";

import {
  GlAccountListUiReducer,
  GlAccountReducer,
  CreateGlAccountReducer,
  GlAccountByIdReducer,
  UpdateGlAccountReducer,
  GlAccountListVersionReducer,
  AproveGlAccountReducer,
  RejectGlAccountReducer,
  BlockGlAccountReducer,
  FreezeGlAccountReducer,
  UnFreezeGlAccountReducer,
  GlAccountVersionDetailsReducer,
  DeleteGlAccountReducer,
  GlAccountLatestVersionReducer
} from "./glAccount/reducer";

import {
  ChargeListUiReducer,
  ChargeListReducer,
  ChargeReducer,
  CreateChargeReducer,
  UpdateChargeReducer,
  ChargeListVersionReducer,
  ApproveChargeReducer,
  RejectChargeReducer,
  SentBackChargeReducer,
  BlockChargeReducer,
  FreezeChargeReducer,
  UnFreezeChargeReducer,
  ChargeVersionDetailsReducer,
  ChargeLatestVersionReducer,
  DeleteChargeReducer,
  CancelChargeReducer
} from "./charge/reducers";
import {
  PayableChargeListUiReducer,
  PayableChargeListReducer,
  PayableChargeReducer,
  CreatePayableChargeReducer,
  UpdatePayableChargeReducer,
  PayableChargeListVersionReducer,
  ApprovePayableChargeReducer,
  RejectPayableChargeReducer,
  BlockPayableChargeReducer,
  FreezePayableChargeReducer,
  UnFreezePayableChargeReducer,
  PayableChargeVersionDetailsReducer,
  PayableChargeLatestVersionReducer,
  DeletePayableChargeReducer,
  CancelPayableChargeReducer
} from "./payableCharge/reducers";
import {
  InstrumentBatchListUiReducer, InstrumentBatchAuditActionsReducer, InstrumentBatchListReducer, InstrumentBatchReducer, UploadInstrumnetBatchReducer } from "./transaction/instrumentBatch/reducer";
import {
  InstrumentListUiReducer, InstrumentReducer, InstrumentsReducer } from "./transaction/instrument/reducer";
import {
  StagingBatchListUiReducer,
  DisburseStagingBatchesReducer,
  StagingBatchListReducer,
  StagingBatchReducer,
  StagingBatchReprocessingReducer,
  StagingBatchSkipValidationReducer,
  StagingBatchVersionReducer,
  AproveStagingBatchesReducer,
  SentBackStagingBatchesReducer,
  RejectStagingBatchesReducer,
  StagingBatchChildListReducer,
  MakerRemarkStagingBatchSkipValidationReducer,
  MakerRemarkDisburseStagingBatchesReducer,
  UpdateStagingBatchLimitTypeReducer,
  StagingBatchAuditActionsReducer,
  StagingBatchReRunValidationsReducer,
  PickupStagingBatchReducer,
  ReleaseStagingBatchReducer
} from "./transaction/stagingBatch/reducer";
import {
  StagingInstrumentListUiReducer,
  SkipableValidationsStagingInstrumentsListReducer,
  StagingInstrumentReducer,
  StagingInstrumentsReprocessingReducer,
  ValidationErrorByStagingInstrumentIdReducer,
  RemoveStagingInstrumentsListReducer,
  StagingInstrumentsRemoveVersionListReducer,
  RemoveStagingInstrumentsReducer,
  StagingInstrumentDocumentsReducer,
  DownloadStagingInstrumentDocumentReducer
} from "./transaction/stagingInstrument/reducer";
import { StagingInstrumentsListReducer, StagingInstrumentsSkipValidationReducer } from "./transaction/stagingInstrument/reducer";
import {
  PaymentInstrumentListUiReducer, PaymentInstrumentReducer, PaymentInstrumnetListReducer } from "./transaction/paymentInstrument/reducer";
import {
  PaymentBatchListUiReducer,
  PaymentBatchListReducer,
  PaymentBatchReducer,
  MarkeRemarkReProcessingPaymentBatchReducer,
  ApprovalPaymentBatchReducer,
  RejectPaymentBatchReducer,
  PaymentBatchVersionListReducer,
  PaymentBatchAuditActionsReducer
} from "./transaction/payment/reducer";

import {
  EodJobReducer,
  EodJobLoggedInUsers,
  ForceLogoutUsersReducer,
  GetEodJobStatusReducer,
  InitialUpdatebusinessDetailReducer,
  GetbusinessDetailReducer,
  UpdatebusinessDetailReducer
} from "./eodBod/reducers";
import {
  DisbursementListUiReducer, DisbursementsReducer } from "./transaction/disbursement/reducer";

import {
  InterestAccrualListUiReducer, IntrumenetInterestAccrualsReducer, IntrumenetInterestAccrualReducer } from "./transaction/interestAccrual/reducer";
import {
  DailyBalanceListUiReducer, InstrumentDailyBalanceReducer, InstrumentDailyBalancesReducer } from "./transaction/dailyBalances/reducer";
import {
  InstrumentDailyBalanceHistoryListUiReducer, InstrumentDailyBalancesHistoryReducer, InstrumentDailyBalanceHistoryReducer } from "./transaction/instrumentDailyBalancesHistory/reducer";

import {
  RepaymentRequestListUiReducer,
  RepaymentListReducer,
  UploadRepaymentReducer,
  RepaymentReducer,
  RepaymentListVersionReducer,
  ApproveRepaymentReducer,
  RejectRepaymentReducer,
  UploadRepaymentSettlementReducer,
  RepaymentFiltersReducer,
  RepaymentAdjustmentEntriesReducer,
  RepaymentAdjustmentEntrieReducer,
  RepaymentStagedAdjustmentEntrieReducer,
  CreateRepaymentRequestSettleReducer,
  RepaymentStagedAdjustmentEntriesReducer,
  CreateRepaymentRequestSettleManuallyReducer,
  ReviewFIFORepaymentReducer,
  RepaymentAuditActionsReducer
} from "./Repayment/repaymentRequest/reducers";

import {
  DisbursementAuthListUiReducer,
  DisbursementAuthListReducer,
  CreateDisbursementAuthReducer,
  DisbursementAuthReducer,
  UpdateDisbursementAuthReducer,
  PublishDisbursementAuthReducer,
  FetchDisbursementAuthVesrions,
  ApproveDisbursementAuthReducer,
  RejectDisbursementAuthReducer,
  BlockDisbursementAuthReducer,
  FreezeDisbursementAuthReducer,
  UnFreezeDisbursementAuthReducer,
  DisbursementAuthAuditActionsReducer,
  DownloadDisbursementAuthReducer,
  DownloadPendingPaymentBatchReducer
} from "./DisbursementAuth/reducer";
import { CreateProgrammeSummaryReducer } from "./report/programmeSummary/reducer";

import { CreateDisbursementAdviceReducer } from "./report/disbursementAdvice/reducer";
import { CreateLimitReportReducer } from "./report/limitReport/reducer";
import { CreateClientSummaryReducer } from "./report/clientSummary/reducer";

import { CreateInterestComputationReducer } from "./report/interestComputation/reducer";
import { CreateRepaymentAdviceReducer } from "./report/repaymentAdvice/reducer";
import { ExcessMoneyListUiReducer, ExcessMoneyListReducer, ExcessMoneyReducer } from "./Repayment/excessMoney/reducer";
import { ExcessRefundListUiReducer, ExcessRefundListReducer, ExcessRefundReducer } from "./Repayment/excessRefund/reducer";
import { ExcessMoneySettlementListUiReducer, ExcessMoneySettlementListReducer, ExcessMoneySettlementReducer } from "./Repayment/excessMoneySettlement/reducer";
import { ApproveExcessMoneyRefundReducer, CreateExcessMoneyRefundReducer, RejectExcessMoneyRefundReducer } from "./Repayment/excessMoneyRefund/reducer";
import {
  InstrumentBatchUploadListUiReducer, InstrumentBatchUploadListReducer, InstrumentBatchUploadReducer, InstrumentsListByBatchIdReducer } from "./transaction/instrumentBatchUpload/reducer";
import { CreateNpaReportReducer } from "./report/npaReport/reducer";
import { CreateLifeCycleReducer } from "./report/lifeCycleReport/reducer";
import {
  ChargeSettlementListUiReducer, ApproveChargeSettlementReducer, ChargeSettlementAuditActionsReducer, ChargeSettlementDetailReducer, ChargeSettlementListReducer, CreateChargeSettlementReducer, RejectChargeSettlementReducer } from "./Repayment/chargeSettlement/reducer";
import { CreateFundingDetailsReducer } from "./report/fundingDetails/reducer";
import {
  ApproveRepaymentBulkIntrumentReducer,
  CreateRepaymentBulkIntrumentReducer,
  RejectRepaymentBulkIntrumentReducer,
  RepaymentBulkIntrumentAuditReducer,
  RepaymentBulkIntrumentDetailReducer,
  RepaymentBulkIntrumentSettledEntriesDetailReducer,
  RepaymentBulkIntrumentSettledEntriesReducer,
  RepaymentBulkIntrumentsFiltersListReducer,
  RepaymentBulkRequestListUiReducer,
  RepaymentBulkIntrumentsListReducer,
  RepaymentBulkIntrumentVersionReducer,
  ReviewRepaymentBulkIntrumentReducer
} from "./Repayment/repayment-intrument-bulk-request/reducer";
import { DownloadReportReducer, ListReportReducer } from "./report/commonReports/reducer";
import { ApproveBulkCustomersFileReducer, BulkCustomersDetailReducer, BulkCustomersPublishReducer, BulkCustomersVersionRecordReducer, DeDuplicateBulkCustomersFileCheckReducer, DeleteBulkCustomersFileReducer, DownloaBulkCustomersReducer, ListBulkCustomersReducer, ListBulkFileSpecificCustomersReducer, RejectBulkCustomersFileReducer, UploadBulkCustomersReducer } from "./bulkCustomer/reducer";
import {
  ApproveBulkCustomerCicReportingFileReducer,
  BulkCustomerCicReportingDetailReducer,
  BulkCustomerCicReportingPublishReducer,
  BulkCustomerCicReportingVersionRecordReducer,
  DeleteBulkCustomerCicReportingFileReducer,
  DownloadBulkCustomerCicReportingReducer,
  ListBulkCustomerCicReportingReducer,
  ListBulkFileSpecificCustomerCicReportingReducer,
  RejectBulkCustomerCicReportingFileReducer,
  UploadBulkCustomerCicReportingReducer
} from "./bulkCustomerCicReporting/reducer";
import { ApproveBulkBuyerSellersFileReducer, BulkBuyerSellersFileDetailReducer, BulkBuyerSellersFileVersionReducer, DeleteBulkBuyerSellersFileReducer, DownloadBulkBuyerSellersFileReducer, ListBulkBuyerSellersFileReducer, ListBulkFileSpecificBuyerSellersReducer, PublishBulkBuyerSellersFileReducer, RejectBulkBuyerSellersFileReducer, UploadBulkBuyerSellersFileReducer } from "./bulkBuyerSeller/reducer";
import { ApproveBulkProgrammesFileReducer, BulkProgrammesFileDetailReducer, BulkProgrammesFileVersionReducer, DeleteBulkProgrammesFileReducer, DownloadBulkProgrammesFileReducer, ListBulkFileSpecificProgrammesReducer, ListBulkProgrammesFileReducer, PublishBulkProgrammesFileReducer, RejectBulkProgrammesFileReducer, UploadBulkProgrammesFileReducer } from "./bulkFinancingProgramme/reducer";
import { ApproveBulkLimitConfigFileReducer, BulkLimitConfigFileDetailReducer, BulkLimitConfigFileVersionReducer, DeleteBulkLimitConfigFileReducer, DownloadBulkLimitConfigFileReducer, ListBulkFileSpecificLimitConfigReducer, ListBulkLimitConfigFileReducer, PublishBulkLimitConfigFileReducer, RejectBulkLimitConfigFileReducer, UploadBulkLimitConfigFileReducer } from "./bulkLimitConfig/reducer";
import { UploadBulkBeneficiaryFileReducer, ListBulkBeneficiaryFileReducer, DownloadBulkBeneficiaryFileReducer, BulkBeneficiaryFileDetailReducer, BulkBeneficiaryFileVersionReducer, PublishBulkBeneficiaryFileReducer, ApproveBulkBeneficiaryFileReducer, RejectBulkBeneficiaryFileReducer, ListBulkFileSpecificBeneficiaryReducer, DeleteBulkBeneficiaryFileReducer } from "./bulkBeneficiary/reducer";
import { CreateOverdueReportReducer } from "./report/overdueReport/reducer";
import { CreateIntegLogReportReducer } from "./report/integLogReport.ts/reducer";
import {
  CoLenderFinancierListUiReducer, CoLenderFinancierListReducer, CoLenderFinancierReducer, CoLenderFinancierVersionsReducer, CreateCoLenderFinancierReducer, DeleteCoLenderFinancierReducer, UpdateCoLenderFinancierReducer , BlockCoLenderFinancierReducer, ApproveCoLenderFinancierReducer, RejectCoLenderFinancierReducer, FreezeCoLenderFinancierReducer, UnfreezeCoLenderFinancierReducer, CoLenderFinancierVersionDetailsReducer, CoLenderFinancierLatestVersionReducer } from "./coLenderFinancier/reducer";
import { CreateStatementOfAccountsReducer } from "./report/statementOfAccounts/reducer";
import { CreateUnrealisedIncomeReportReducer } from "./report/unrealisedIncome/reducer";
import { CreateOneViewReportReducer } from "./report/oneViewReport/reducer";
import { CreateChargeSummaryReportReducer } from "./report/chargeSummary/reducer";
import { CreateAmortizationReportReducer } from "./report/amortizationReport/reducer";
import { CreateBuyerSellerDumpReportReducer } from "./report/buyerSellerDump/reducer";
import { CreateProgrammesDumpReportReducer } from "./report/programmesDump/reducer";
import { CreateCustomerDumpReportReducer } from "./report/customerDump/reducer";
import { CreateCrilicReportReducer } from "./report/crilicReport/reducer";

const appReducer = combineReducers({
  Auth,
  LoginHistoryReducer,
  FieldConfigListReducer,
  ChangePasswordReducer,
  ResetPasswordReducer,
  GenerateOtpReducer,
  ValidateOtpReducer,
  Layout,
  WorkspaceTabs,

  FinancierUserListReducer,
  FinancierUserListUiReducer,
  FinancierUserReducer,
  CreateFinancierUserReducer,
  UpdateFinancierUserReducer,
  FetchFinancierUserVesrions,
  ApproveFinancierUserReducer,
  RejectFinancierUserReducer,
  BlockFinancierUserReducer,
  FreezeFinancierUserReducer,
  UnFreezeFinancierUserReducer,
  FetchFinancierUserVesrionDetails,
  DeleteFinancierUserReducer,
  FetchFinancierUserLatestVesrionReducer,
  ModulePermissionListReducer,
  FetchUserRoleVesrionsDetails,
  FetchUserRoleLatestVesrionsReducer,
  FetchCurrencyLatestVerionReducer,
  DeleteUserRoleReducer,

  UserRoleListReducer,
  UserRoleListUiReducer,
  CreateUserRoleReducer,
  UserRoleReducer,
  UpdateUserRoleReducer,
  FetchUserRoleVesrions,
  ApproveUserRoleReducer,
  RejectUserRoleReducer,

  CurrencyListReducer,
  CurrencyListUiReducer,
  CreateCurrencyReducer,
  CurrencyReducer,
  UpdateCurrencyReducer,
  DeleteCurrencyReducer,
  CurrencyVersionListReducer,
  aproveCurrencyReducer,
  rejectCurrencyReducer,
  blockCurrencyReducer,
  FreezeCurrencyReducer,
  UnFreezeCurrencyReducer,
  CurrencyVersionDetailsReducer,

  BaseRateListReducer,
  BaseRateListUiReducer,
  BaseRateReducer,
  NormalBaseRateReducer,
  AdhocBaseRateReducer,
  CreateBaseRateReducer,
  UpdateBaseRateReducer,
  FetchBaseRateVesrions,
  ApproveBaseRateReducer,
  RejectBaseRateReducer,
  BlockBaseRateReducer,
  FreezeBaseRateReducer,
  UnFreezeBaseRateReducer,
  FetchBaseRateVesrionsDetailsReducer,
  BaseRateReducerLatestVersionReducer,
  DeleteBaseRateReducer,
  HolidayListReducer,
  HolidayListUiReducer,
  HolidayLatestVersionReducer,
  DeleteHolidayReducer,
  CreateHolidayReducer,
  HolidayReducer,
  UpdateHolidayReducer,
  FetchHolidayVesrions,
  ApproveHolidayReducer,
  RejectHolidayReducer,
  BlockHolidayReducer,
  FreezeHolidayReducer,
  UnFreezeHolidayReducer,
  HolidayVersionDetailsReducer,

  HolidayBatchListReducer,
  HolidayBatchListUiReducer,
  CreateHolidayBatchReducer,
  HolidayBatchReducer,
  UpdateHolidayBatchReducer,
  FetchHolidayBatchVesrions,
  ApproveHolidayBatchReducer,
  RejectHolidayBatchReducer,
  PublishHolidayBatchReducer,
  HolidayBatchFilterReducer,
  HolidayBatchVersionDetailsReducer,
  DownloadHolidayBatchReducer,

  BranchListReducer,
  BranchListUiReducer,
  BranchVersionDetailsReducer,
  BranchReducerLatestVerionReducer,
  DeleteBranchReducer,

  CreateBranchReducer,
  BranchReducer,
  FetchBranchVesrions,
  ApproveBranchReducer,
  RejectBranchReducer,
  UpdateBranchReducer,
  BlockBranchReducer,
  FreezeBranchReducer,
  UnFreezeBranchReducer,

  CountryListReducer,
  CountryListUiReducer,
  CreateCountryReducer,
  CountryReducer,
  UpdateCountryReducer,
  CountryVersionListReducer,
  approveCountryReducer,
  rejectCountryReducer,
  blockCountryReducer,
  FreezeCountryReducer,
  UnFreezeCountryReducer,
  CountryVersionDetailsReducer,
  CountryReducerLatestVersionReducer,
  DeleteCountryReducer,

  StateListReducer,
  StateListUiReducer,
  CreateStateReducer,
  StateReducer,
  UpdateStateReducer,
  StateListVersionReducer,
  ApproveStateReducer,
  RejectStateReducer,
  BlockStateReducer,
  FreezeStateReducer,
  UnFreezeStateReducer,
  StateVersionDetailsReducer,
  StateLatestVersionReducer,
  DeleteStateReducer,

  RelationshipManagerListReducer,
  RelationshipManagerListUiReducer,
  CreaterelationshipManagerReducer,
  RelationshipMaanagerReducer,
  UpdateRelationshipMaanagerReducer,
  RelationshipManagerListVersionReducer,
  AproveRelationshipManagerReducer,
  RejectRelationshipManagerReducer,
  BlockRelationshipManagerReducer,
  FreezeRelationshipManagerReducer,
  UnFreezeRelationshipManagerReducer,
  RelationshipMaanagerVersionDetailsReducer,
  RelationshipMaanagerLatestVersionReducer,
  DeleteRelationshipMaanagerReducer,

  LovListReducer,
  LovListUiReducer,
  CreateLovListReducer,
  LovByIdReducer,
  UpdateLovReducer,
  LovListTenorReducer,
  LovListVersionReducer,
  AproveLovReducer,
  RejectLovReducer,
  BlockLovReducer,
  FreezeLovReducer,
  UnFreezeLovReducer,
  LovListVersionDetailsReducer,
  LovLatestVersionReducer,
  deleteLOVReducer,

  GlAccountReducer,
  GlAccountListUiReducer,
  CreateGlAccountReducer,
  GlAccountByIdReducer,
  UpdateGlAccountReducer,
  GlAccountListVersionReducer,
  AproveGlAccountReducer,
  RejectGlAccountReducer,
  BlockGlAccountReducer,
  FreezeGlAccountReducer,
  UnFreezeGlAccountReducer,
  GlAccountVersionDetailsReducer,
  DeleteGlAccountReducer,

  CityListReducer,
  CityListUiReducer,
  CreateCityReducer,
  CityReducer,
  UpdateCityReducer,
  CityListVersionReducer,
  ApproveCityReducer,
  RejectCityReducer,
  BlockCityReducer,
  FreezeCityReducer,
  UnFreezeCityReducer,
  CityVersionDetailsReducer,
  CityReducerLatestVersionReducer,
  DeleteCityReducer,
  ZipLookupReducer,

  CoLenderFinancierListReducer,
  CoLenderFinancierListUiReducer,
  CreateCoLenderFinancierReducer,
  UpdateCoLenderFinancierReducer,
  CoLenderFinancierReducer,
  DeleteCoLenderFinancierReducer,
  CoLenderFinancierVersionsReducer,
  CoLenderFinancierVersionDetailsReducer,
  CoLenderFinancierLatestVersionReducer,
  BlockCoLenderFinancierReducer,
  ApproveCoLenderFinancierReducer,
  RejectCoLenderFinancierReducer,
  FreezeCoLenderFinancierReducer,
  UnfreezeCoLenderFinancierReducer,

  CustomerIdsReducer,
  CustomerListReducer,
  CustomerListUiReducer,
  CustomerReducer,
  CustomerVersionsReducer,
  ApproveCustomerReducer,
  RejectCustomerReducer,
  SentBackCustomerReducer,
  TaskIdByPanNumberReducer,
  TaskStatusByTaskIdReducer,
  TaskResultByTaskIdReducer,
  GstDetailReducer,
  CustomerValidateReducer,
  CreateCustomerReducer,
  UpdateCustomerReducer,
  UploadBulkCustomersReducer,
  ListBulkCustomersReducer,
  BulkCustomersDetailReducer,
  BulkCustomersVersionRecordReducer,
  BulkCustomersPublishReducer,
  DownloaBulkCustomersReducer,
  ListBulkFileSpecificCustomersReducer,
  ApproveBulkCustomersFileReducer,
  RejectBulkCustomersFileReducer,
  DeDuplicateBulkCustomersFileCheckReducer,
  DeleteBulkCustomersFileReducer,

  UploadBulkCustomerCicReportingReducer,
  ListBulkCustomerCicReportingReducer,
  BulkCustomerCicReportingDetailReducer,
  BulkCustomerCicReportingVersionRecordReducer,
  BulkCustomerCicReportingPublishReducer,
  DownloadBulkCustomerCicReportingReducer,
  ListBulkFileSpecificCustomerCicReportingReducer,
  ApproveBulkCustomerCicReportingFileReducer,
  RejectBulkCustomerCicReportingFileReducer,
  DeleteBulkCustomerCicReportingFileReducer,

  CustomerCICReportingIdsReducer,
  CustomerCICReportingListReducer,
  CustomerCICReportingListUiReducer,
  CustomerCICReportingReducer,
  CustomerCICReportingVersionReducer,
  CustomerCICReportingLatestVersionReducer,
  CustomerCICReportingVersionsDetailReducer,
  CreateCustomerCICReportingReducer,
  DeleteCustomerCICReportingReducer,
  ApproveCustomerCICReportingReducer,
  RejectCustomerCICReportingReducer,
  SentBackCustomerCICReportingReducer,
  UpdateCustomerCICReportingReducer,

  CreateCustomerContactReducer,
  FetchCustomerByProgrammeIdReducer,
  CustomerContactListReducer,
  DeDuplicateCustomerReducer,
  CustomerFreezeReducer,
  CustomerUnFreezeReducer,
  CustomerVersionsDetailsReducer,
  CustomerLatestVersionsReducer,
  DeleteCustomerReducer,
  CustomerContactBYIdReducer,
  UpdateCustomerContactReducer,
  KeyManagementContactReducer,
  UpdateKeyManagementContactReducer,
  FetchPatnerContactListReducer,
  FetchPartnerContactBYIdReducer,
  UpdatePartnerContactReducer,
  CustomerBlockReducer,
  CustomerContactListVersionReducer,
  AproveCustomerContactReducer,
  RejectCustomerContactReducer,
  SentBackCustomerContactReducer,
  BlockCustomerContactReducer,
  KeyManagementListVersionReducer,
  AproveKeyManagementReducer,
  RejectKeyManagementReducer,
  SentBackKeyManagementReducer,
  BlockKeyManagementReducer,
  PartnerContactListVersionReducer,
  AprovePartnerContactReducer,
  RejectPartnerContactReducer,
  SentBackPartnerContactReducer,
  BlockPartnerContactReducer,
  CreatePartnerContactReducer,
  CreateKeyManagmentContactReducer,
  KeyManagementContactListReducer,

  FreezeCustomerContactReducer,
  FreezePartnerContactReducer,
  FreezeKeyManagementReducer,

  UnFreezePartnerContactReducer,
  UnFreezeKeyManagementReducer,
  UnFreezeCustomerContactReducer,
  CustomerContactVersionDetailsReducer,
  DeleteCustomerContactReducer,

  CustomerAddressListReducer,
  CreateAddressReducer,
  CustomerAddressReducer,
  UpdateCustomerAddressReducer,
  AddressListVersionReducer,
  AproveCustomerAddressReducer,
  RejectCustomerAddressReducer,
  SentBackCustomerAddressReducer,
  BlockCustomerAddressReducer,
  FreezeCustomerAddressReducer,
  UnFreezeCustomerAddressReducer,
  FetchAddressVersionDetailsReducer,
  FetchAddressLatestVersionReducer,
  DeleteAddressReducer,

  CustomerCummunicationsListReducer,
  CustomerCummunicationsCreatereducer,
  CustomerCummunicationsBYIdReducer,
  UpdateCustomerCummunicationsReducer,
  DeleteCustomerCummunicationsReducer,
  CustomerCummunicationsListVersionReducer,
  AproveCummunicationsReducer,
  RejectCummunicationsReducer,
  SentBackCummunicationsReducer,
  BlockCummunicationsReducer,
  FreezeCummunicationsReducer,
  UnFreezeCummunicationsReducer,
  CustomerCummunicationsVersionDetailsReducer,
  CustomerCummunicationsLatestVersionReducer,

  LimitConfigListReducer,
  FetchLimitConfigByCustomerReducer,
  CreateLimitConfigReducer,
  deleteLimitConfigReducer,
  UpdateLimitConfigReducer,
  FetchLimitConfigVesrions,
  ApproveLimitConfigReducer,
  RejectLimitConfigReducer,
  SentBackLimitConfigReducer,
  BlockLimitConfigReducer,
  FreezeLimitConfigReducer,
  UnFreezeLimitConfigReducer,
  FetchLimitConfigHistroyReducer,
  FetchAggregateLimitConfigHistroyReducer,
  FetchLimitConfigVersionDetailsReducer,
  FetchLimitConfigLatestVersionReducer,
  ProductLimitConfigListReducer,
  CreateProductLimitConfigReducer,
  FetchProductLimitConfigReducer,
  UpdateProductLimitConfigReducer,
  ListApprovedLimitsV2Reducer,
  LatestVersionLimitsV2Reducer,
  CreateDraftLimitV2Reducer,
  PublishLimitV2Reducer,
  UpdateDraftLimitV2Reducer,
  ApproveLimitV2Reducer,
  RejectLimitV2Reducer,
  SentBackLimitV2Reducer,
  DeleteLimitV2Reducer,
  DeleteLimitV2ByExternalIdReducer,
  FreezeLimitV2Reducer,
  UnfreezeLimitV2Reducer,
  LimitConfigListUiReducer,

  //bulk limit config
  UploadBulkLimitConfigFileReducer,
  ListBulkLimitConfigFileReducer,
  DownloadBulkLimitConfigFileReducer,
  BulkLimitConfigFileDetailReducer,
  BulkLimitConfigFileVersionReducer,
  PublishBulkLimitConfigFileReducer,
  ApproveBulkLimitConfigFileReducer,
  RejectBulkLimitConfigFileReducer,
  ListBulkFileSpecificLimitConfigReducer,
  DeleteBulkLimitConfigFileReducer,

  ProdcutTypeListReducer,
  ProductTypeListUiReducer,
  ProdcutTypeReducer,
  UpdateProductTypeReducer,
  CreateProdcutTypeReducer,
  ProdcutTypeListVersionReducer,
  RejectProductTypeReducer,
  AproveProductTypeReducer,
  BlockProductTypeReducer,
  FreezeProductTypeReducer,
  UnFreezeProductTypeReducer,
  ProdcutTypeDetailsReducer,
  ProdcutTypeLatestVersionReducer,
  DeleteProductTypeReducer,
  GlAccountLatestVersionReducer,
  ChargeListReducer,
  ChargeListUiReducer,
  ChargeReducer,
  CreateChargeReducer,
  UpdateChargeReducer,
  ChargeListVersionReducer,
  ApproveChargeReducer,
  RejectChargeReducer,
  SentBackChargeReducer,
  BlockChargeReducer,
  FreezeChargeReducer,
  UnFreezeChargeReducer,
  ChargeVersionDetailsReducer,
  ChargeLatestVersionReducer,
  DeleteChargeReducer,
  CancelChargeReducer,

  PayableChargeListReducer,
  PayableChargeListUiReducer,
  PayableChargeReducer,
  CreatePayableChargeReducer,
  UpdatePayableChargeReducer,
  PayableChargeListVersionReducer,
  ApprovePayableChargeReducer,
  RejectPayableChargeReducer,
  BlockPayableChargeReducer,
  FreezePayableChargeReducer,
  UnFreezePayableChargeReducer,
  PayableChargeVersionDetailsReducer,
  PayableChargeLatestVersionReducer,
  DeletePayableChargeReducer,
  CancelPayableChargeReducer,

  CustomerBeneficiaryListReducer,
  CreateCustomerBeneficiaryReducer,
  CustomerBeneficiaryVersionListReducer,
  AproveBeneficiaryReducer,
  RejectBeneficiaryReducer,
  SentBackBeneficiaryReducer,
  BlockBeneficiaryReducer,
  FreezeBeneficiaryReducer,
  UnFreezeBeneficiaryReducer,
  CustomerBeneficiaryVersionDetailsReducer,
  CustomerBeneficiaryLatestVersionReducer,
  DeleteCustomerBeneficiaryReducer,

  FinancingProgramListReducer,
  FinancinProgramReducer,
  FinancingProgramListUiReducer,
  FinancingProgramVersionsReducer,
  ApproveFinancinProgramReducer,
  RejectFinancinProgramReducer,
  SentBackFinancinProgramReducer,
  FinancingProgramValidateReducer,
  CreateFinancinProgramReducer,
  UpdateFinancinProgramReducer,
  FinancinProgramVersionDetailsReducer,
  FinancingProgramLatestVersionsReducer,
  DeleteFinancinProgramReducer,
  GenerateLoanAccountNumberFinancinProgramReducer,
  BlockFinancingProgramReducer,
  FreezeFinancingProgramReducer,
  UnFreezeFinancingProgramReducer,
  FinancingProgramIdsReducer,
  FinancingProgramConfigListReducer,
  FinancingProgramForRepaymentsReducer,

  CustomerBeneficiaryReducer,
  FetchLimitConfigReducer,
  LimitConfigIdsReducer,
  UpdateBeneficiaryReducer,

  //bulk financing programme
  UploadBulkProgrammesFileReducer,
  ListBulkProgrammesFileReducer,
  DownloadBulkProgrammesFileReducer,
  BulkProgrammesFileDetailReducer,
  BulkProgrammesFileVersionReducer,
  PublishBulkProgrammesFileReducer,
  ApproveBulkProgrammesFileReducer,
  RejectBulkProgrammesFileReducer,
  ListBulkFileSpecificProgrammesReducer,
  DeleteBulkProgrammesFileReducer,

  //buyerSeller
  BuyerSellerIdsReducer,
  BuyerSellersListReducer,
  BuyerSellerListUiReducer,
  BuyerSellerCreateRelationAccountNumberReducer,
  BuyerSellerVersionDetailsReducer,
  BuyerSellerLatestVersionReducer,
  DeleteBuyerSellerReducer,
  BuyerSellerReducer,
  BuyerSellerVersionsReducer,
  ApproveBuyerSellerReducer,
  RejectBuyerSellerReducer,
  SentBackBuyerSellerReducer,
  BuyerSellerBlockReducer,
  UpdateBuyerSellerReducer,
  BuyerSellerValidateReducer,
  CreateBuyerSellerReducer,
  FreezeBuyerSellerReducer,
  UnFreezeBuyerSellerReducer,
  BuyerSellerPartialDisbursementAllowedReducer,
  BuyerSellerConfigValues,
  ProgrammeAndCounterparyBasedBuyerSellerReducer,

  CustomerBeneficiaryProgrammeListReducer,
  CreateCustomerBeneficiaryProgrammeReducer,
  CustomerBeneficiaryProgrammeReducer,
  UpdateBeneficiaryProgrammeReducer,
  CustomerBeneficiaryProgrammeVersionListReducer,
  AproveBeneficiaryProgrammeReducer,
  RejectBeneficiaryProgrammeReducer,
  BlockBeneficiaryProgrammeReducer,

  //bulk buyerSeller
  UploadBulkBuyerSellersFileReducer,
  ListBulkBuyerSellersFileReducer,
  DownloadBulkBuyerSellersFileReducer,
  BulkBuyerSellersFileDetailReducer,
  BulkBuyerSellersFileVersionReducer,
  PublishBulkBuyerSellersFileReducer,
  ApproveBulkBuyerSellersFileReducer,
  RejectBulkBuyerSellersFileReducer,
  ListBulkFileSpecificBuyerSellersReducer,

  //bulk beneficiary
  UploadBulkBeneficiaryFileReducer,
  ListBulkBeneficiaryFileReducer,
  DownloadBulkBeneficiaryFileReducer,
  BulkBeneficiaryFileDetailReducer,
  BulkBeneficiaryFileVersionReducer,
  PublishBulkBeneficiaryFileReducer,
  ApproveBulkBeneficiaryFileReducer,
  RejectBulkBeneficiaryFileReducer,
  ListBulkFileSpecificBeneficiaryReducer,
  DeleteBulkBeneficiaryFileReducer,
  DeleteBulkBuyerSellersFileReducer,

  InstrumentBatchListReducer,
  InstrumentBatchListUiReducer,
  UploadInstrumnetBatchReducer,
  InstrumentBatchReducer,
  InstrumentBatchAuditActionsReducer,
  InstrumentBatchUploadListReducer,
  InstrumentBatchUploadListUiReducer,
  InstrumentBatchUploadReducer,
  InstrumentsListByBatchIdReducer,
  InstrumentReducer,
  InstrumentsReducer,
  InstrumentListUiReducer,
  FreezeBeneficiaryProgrammeReducer,
  UnFreezeBeneficiaryProgrammeReducer,
  StagingBatchListReducer,
  StagingBatchListUiReducer,
  StagingBatchReducer,
  StagingInstrumentsListReducer,
  StagingInstrumentListUiReducer,
  StagingInstrumentReducer,
  StagingInstrumentsReprocessingReducer,
  StagingInstrumentsSkipValidationReducer,
  StagingBatchReRunValidationsReducer,
  StagingInstrumentDocumentsReducer,
  DownloadStagingInstrumentDocumentReducer,
  PaymentBatchListReducer,
  PaymentBatchListUiReducer,
  MarkeRemarkReProcessingPaymentBatchReducer,
  PaymentBatchAuditActionsReducer,
  ApprovalPaymentBatchReducer,
  RejectPaymentBatchReducer,
  PaymentBatchVersionListReducer,
  StagingBatchSkipValidationReducer,
  StagingBatchReprocessingReducer,
  PaymentInstrumnetListReducer,
  PaymentInstrumentListUiReducer,
  PaymentInstrumentReducer,
  PaymentBatchReducer,
  DisburseStagingBatchesReducer,
  StagingBatchVersionReducer,
  AproveStagingBatchesReducer,
  SentBackStagingBatchesReducer,
  RejectStagingBatchesReducer,
  StagingBatchChildListReducer,
  MakerRemarkStagingBatchSkipValidationReducer,
  MakerRemarkDisburseStagingBatchesReducer,
  SkipableValidationsStagingInstrumentsListReducer,
  ValidationErrorByStagingInstrumentIdReducer,
  RemoveStagingInstrumentsListReducer,
  StagingInstrumentsRemoveVersionListReducer,
  UpdateStagingBatchLimitTypeReducer,
  RemoveStagingInstrumentsReducer,
  StagingBatchAuditActionsReducer,
  PickupStagingBatchReducer,
  ReleaseStagingBatchReducer,

  EodJobReducer,
  EodJobLoggedInUsers,
  GetbusinessDetailReducer,
  UpdatebusinessDetailReducer,
  GetEodJobStatusReducer,
  InitialUpdatebusinessDetailReducer,
  DisbursementsReducer,
  DisbursementListUiReducer,
  ForceLogoutUsersReducer,

  IntrumenetInterestAccrualsReducer,
  InterestAccrualListUiReducer,
  IntrumenetInterestAccrualReducer,
  InstrumentDailyBalanceReducer,
  InstrumentDailyBalancesReducer,
  DailyBalanceListUiReducer,

  //repayment
  RepaymentListReducer,
  RepaymentRequestListUiReducer,
  UploadRepaymentReducer,
  RepaymentReducer,
  RepaymentListVersionReducer,
  ApproveRepaymentReducer,
  RejectRepaymentReducer,
  UploadRepaymentSettlementReducer,
  RepaymentFiltersReducer,
  RepaymentAdjustmentEntriesReducer,
  RepaymentAdjustmentEntrieReducer,
  RepaymentStagedAdjustmentEntrieReducer,
  CreateRepaymentRequestSettleReducer,
  CreateRepaymentRequestSettleManuallyReducer,
  ReviewFIFORepaymentReducer,
  RepaymentStagedAdjustmentEntriesReducer,
  InstrumentDailyBalancesHistoryReducer,
  InstrumentDailyBalanceHistoryListUiReducer,
  InstrumentDailyBalanceHistoryReducer,
  ExcessMoneyListReducer,
  ExcessMoneyListUiReducer,
  ExcessMoneyReducer,
  ExcessRefundListReducer,
  ExcessRefundListUiReducer,
  ExcessRefundReducer,
  ExcessMoneySettlementReducer,
  ExcessMoneySettlementListReducer,
  ExcessMoneySettlementListUiReducer,
  CreateExcessMoneyRefundReducer,
  ApproveExcessMoneyRefundReducer,
  RejectExcessMoneyRefundReducer,
  ChargeSettlementDetailReducer,
  ChargeSettlementListReducer,
  ChargeSettlementListUiReducer,
  ChargeSettlementAuditActionsReducer,
  CreateChargeSettlementReducer,
  ApproveChargeSettlementReducer,
  RejectChargeSettlementReducer,
  CreateRepaymentBulkIntrumentReducer,
  RepaymentBulkIntrumentsListReducer,
  RepaymentBulkRequestListUiReducer,
  RepaymentBulkIntrumentDetailReducer,
  RepaymentBulkIntrumentVersionReducer,
  RepaymentBulkIntrumentsFiltersListReducer,
  ApproveRepaymentBulkIntrumentReducer,
  RejectRepaymentBulkIntrumentReducer,
  RepaymentBulkIntrumentSettledEntriesReducer,
  RepaymentBulkIntrumentSettledEntriesDetailReducer,
  ReviewRepaymentBulkIntrumentReducer,
  RepaymentAuditActionsReducer,
  RepaymentBulkIntrumentAuditReducer,

  DisbursementAuthListReducer,
  DisbursementAuthListUiReducer,
  CreateDisbursementAuthReducer,
  DisbursementAuthReducer,
  UpdateDisbursementAuthReducer,
  PublishDisbursementAuthReducer,
  FetchDisbursementAuthVesrions,
  ApproveDisbursementAuthReducer,
  RejectDisbursementAuthReducer,
  BlockDisbursementAuthReducer,
  FreezeDisbursementAuthReducer,
  UnFreezeDisbursementAuthReducer,
  CreateDisbursementAdviceReducer,
  ListReportReducer,
  DownloadReportReducer,
  CreateLimitReportReducer,
  CreateClientSummaryReducer,
  CreateStatementOfAccountsReducer,
  DisbursementAuthAuditActionsReducer,
  DownloadDisbursementAuthReducer,
  DownloadPendingPaymentBatchReducer,
  CreateInterestComputationReducer,
  CreateRepaymentAdviceReducer,
  CreateProgrammeSummaryReducer,
  CreateNpaReportReducer,
  CreateOverdueReportReducer,
  CreateLifeCycleReducer,
  CreateFundingDetailsReducer,
  CreateIntegLogReportReducer,
  CreateUnrealisedIncomeReportReducer,
  CreateOneViewReportReducer,
  CreateChargeSummaryReportReducer,
  CreateAmortizationReportReducer,
  CreateBuyerSellerDumpReportReducer,
  CreateProgrammesDumpReportReducer,
  CreateCustomerDumpReportReducer,
  CreateCrilicReportReducer,

  SystemParameterListReducer,
  SystemParameterListUiReducer,
  SystemParameterReducer,
  UpdateSystemParameterReducer,
  SystemParameterListVersionReducer,
  SystemParameterVersionDetailsReducer,
  SystemParameterLatestVersionReducer,
  ApproveSystemParameterReducer,
  RejectSystemParameterReducer,

  DashboardOperationsSummaryReducer,
  RenewalAndExpiryReducer,
  TxnsByUserReducer,
  ProgramPerformanceReducer,
  ProductMixReducer,
  DashboardPortfolioAnalyticsSummaryReducer,
  AgeingBucketsReducer,
  DisbursementByFYGraphReducer
});

type AppState = ReturnType<typeof appReducer>;

const rootReducer: Reducer = (state: AppState | undefined, action: AnyAction) => {
  if (action.type === APP_CLEAR_STORE) {
    state = undefined;
  }
  return (appReducer as Reducer)(state, action);
};

export default rootReducer;
